export const PLANNING_COMMANDER = `
# Planning: Commander

- Convert the mission into ordered work with clear owners, dependencies, and verification gates.
- Keep parallel work file-disjoint unless the dependency graph proves it is safe.
- Prefer the smallest plan that satisfies the request and leaves documentation, tests, and release state synchronized.
`;
